<template>
  <div>
    <el-row align="middle">
      <block-select :template-info="templateInfo"></block-select>
      <div style="height: 40px;line-height: 40px;overflow:hidden;">
      <el-button class="toolButton" id="zoomIn" icon="el-icon-zoom-in" size="medium" circle @click="zoomIn"/>
      <el-button class="toolButton" id="zoomOut" icon="el-icon-zoom-out" size="medium" circle @click="zoomOut"/>
      <el-button class="toolButton" id="zoomFit" icon="el-icon-rank" size="medium" circle @click="zoomFit"/>
      <el-button class="toolButton" id="zommRect" icon="el-icon-search" size="medium" circle @click="zoomRect" />
      <el-divider direction="vertical" content-position="center"></el-divider>
      <span style="margin-right: 5px">旋转角度</span>
      <el-input-number v-model="rotateAngle" size="small" :min="-180" :max="180" :step="10" :step-strictly="true" @change="setRotateAngle">
      </el-input-number>
      <el-divider direction="vertical"></el-divider>
      <span style="margin-right: 5px">砂体连通</span>
        <el-switch v-model="showConnect" style="margin:0 15px 0 0;" @change="setShowConnect">
        </el-switch>
      <span style="margin-right: 5px">图例</span>
        <el-switch v-model="showLegend" style="margin:0 15px 0 0;" @change="setShowLegend">
        </el-switch>
      </div>
      <el-button id="setting" size="mini" type="primary" @click="setupTemplate">模板设置</el-button>
      <el-button id="templateConfig" size="mini" type="primary" @click="manageTemplate" style="margin-left:5px">模板管理</el-button>
      <el-button size="mini" type="primary" @click="recreateFence" style="margin-left:5px">重新生成</el-button>
    </el-row>
    <div v-show="showConfig" class="settingsMask">
      <div class="settingsBack">
        <div>
          <div class="settingsHeader">
            <span>栅状图设置</span>
          </div>
          <FenceConfig ref="fenceEdit" class="settings" :fence="fenceConfig" :fence-wells="fenceWells"></FenceConfig>
          <div class="btnGroup">
            <el-button @click="templateSaveAs">将当前设置另存模板</el-button>
            <el-button @click="cancelConfig">返回</el-button>
            <el-button @click="submitConfig">确定</el-button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-scrollbar v-loading = "fenceLoading" native="true" id="fence_scrollbar"
                    :wrap-style="{'overflow': 'auto', 'max-height': maxScrollHeight, 'overflow-x': 'auto'}">
        <div id="fence_container" class="fence_container">
        </div>
      </el-scrollbar>
    </div>

    <div v-dialogDrag>
      <el-dialog v-model="setupDialogVisible" title="模板管理" width="30%">
        <el-row>
          <el-col :span="20" :offset="1">
            <el-table :data="templateNames" highlight-current-row @current-change="templateSelectChange"
                      style="margin-bottom:20px">
              <el-table-column prop="name" label="模板"/>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" :offset="6">
            <el-button size="medium" @click="deleteTemplate">删除</el-button>
          </el-col>
          <el-col :span="5">
            <el-button size="medium" @click="clickSaveAs">另存</el-button>
          </el-col>
          <el-col :span="5">
            <el-button size="medium" @click="applyTemplate">应用到当前</el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </div>

    <div v-dialogDrag>
      <el-dialog v-model="saveAsVisible" title="模板保存" width="30%">
        <el-row>
          <el-col :span="22" :offset="1">
            <el-radio-group v-model="saveAsTemplateType" class="ml-4">
              <el-radio :label=1 size="medium">系统模板</el-radio>
              <el-radio :label=2 size="medium">个人模板</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22" :offset="1" style="margin-top: 20px;margin-bottom: 20px">
            <el-input v-model="saveAsTemplateName"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" :offset="14">
            <el-button size="medium" @click="saveTemplateOK">确定</el-button>
          </el-col>
          <el-col :span="5">
            <el-button size="medium" @click="saveTemplateCancel">取消</el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </div>

    <div v-dialogDrag>
      <el-dialog v-model="initDialogVisible" title="创建栅状图" width="30" :close-on-click-modal="false">
        <div v-if="fenceStep === 0" style="margin-bottom: 200px">
          <el-row style="margin-top: 50px">
            <el-col :offset="1" :span="3">
              <span>成图方式</span>
            </el-col>
            <el-col :span="10">
              <el-radio-group v-model="dataType">
                <el-radio :label="0" size="large">系统数据</el-radio>
                <el-radio :label="1" size="large">个人数据</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </div>
        <div v-if="fenceStep === 1 && dataType === 0">
          <el-row>
            <el-col :span="9" :offset="1">
              <el-table ref="currentWellTable" border height="250" max-height="250"
                        @selection-change="blockWellCheckChange" :data="currentBlockWells" highlight-current-row>
                <el-table-column type="selection" width="55"/>
                <el-table-column prop="wellName" label="当前区块井"/>
              </el-table>
            </el-col>
            <el-col :span="4">
              <!--          <el-row style="margin-top: 20px" justify="center">-->
              <!--            <el-button size="mini" icon="el-icon-d-arrow-right" circle @click="addAllWell">  </el-button>-->
              <!--          </el-row>-->
              <el-row style="margin-top: 50px" justify="center">
                <el-button size="mini" icon="el-icon-arrow-right" circle @click="addSelectedWell"></el-button>
              </el-row>
              <el-row style="margin-top: 10px" justify="center">
                <el-button size="mini" icon="el-icon-arrow-left" circle @click="removeSelectedWell"></el-button>
              </el-row>
              <!--          <el-row style="margin-top: 10px"  justify="center">-->
              <!--            <el-button size="mini" icon="el-icon-d-arrow-left" circle @click="removeAllWell"> </el-button>-->
              <!--          </el-row>-->
              <el-row style="margin-top: 10px" justify="center">
                <el-button size="mini" icon="el-icon-arrow-up" circle @click="moveUp"></el-button>
              </el-row>
              <el-row style="margin-top: 10px" justify="center">
                <el-button size="mini" icon="el-icon-arrow-down" circle @click="moveDown"></el-button>
              </el-row>
            </el-col>
            <el-col :span="9">
              <el-table ref="selectedWellTable" border height="250" max-height="250"
                        @selection-change="selectWellCheckChange" :data="selectedWells" highlight-current-row>
                <el-table-column type="selection" width="55"/>
                <el-table-column prop="wellName" label="选中井"/>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <div v-if="fenceStep === 1 && dataType === 1">
          <input type="file" name="file" ref="upload" style="display: none" accept=".xls,.xlsx"
                 @change="takeExcelInfo()"/>
          <el-row align="middle" style="margin-bottom: 10px">
            <el-col :span="3">
              <span>地层数据:</span>
            </el-col>
            <el-col :span="9">
              <el-input size="small" v-model="local_tableData[0].fileName" placeholder="Please input"
                        style="width: 150px"/>
              <el-button size="mini" type="primary" @click="layerDataSet(0,'stratum')">选择</el-button>
            </el-col>
            <el-col :span="3">
              <span>砂岩数据:</span>
            </el-col>
            <el-col :span="9">
              <el-input size="small" v-model="local_tableData[1].fileName" placeholder="Please input"
                        style="width: 150px"/>
              <el-button size="mini" type="primary" @click="layerDataSet(1,'stratum')">选择</el-button>
            </el-col>
          </el-row>
          <el-row align="middle" style="margin-bottom: 10px">
            <el-col :span="3">
              <span>射孔数据:</span>
            </el-col>
            <el-col :span="9">
              <el-input size="small" v-model="local_tableData[2].fileName" placeholder="Please input"
                        style="width: 150px"/>
              <el-button size="mini" type="primary" @click="layerDataSet(2,'stratum')">选择</el-button>
            </el-col>
            <el-col :span="3">
              <span>解释结论:</span>
            </el-col>
            <el-col :span="9">
              <el-input size="small" v-model="local_tableData[3].fileName" placeholder="Please input"
                        style="width: 150px"/>
              <el-button size="mini" type="primary" @click="layerDataSet(3,'stratum')">选择</el-button>
            </el-col>
          </el-row>
          <!--        <el-row align="middle" style="margin-bottom: 10px">-->
          <!--          <el-col :span="3">-->
          <!--            <span>曲线数据:</span>-->
          <!--          </el-col>-->
          <!--          <el-col :span="9">-->
          <!--            <el-input size="small" v-model="local_tableData[4].fileName" placeholder="Please input" style="width: 150px"/>-->
          <!--            <el-button size="mini" type="primary" @click="layerDataSet(4,'stratum')" >选择</el-button>-->
          <!--          </el-col>-->
          <!--        </el-row>-->
        </div>
        <div v-if="fenceStep === 2 && dataType === 0" style="margin-bottom: 124px">
          <el-row align="middle" style="margin-bottom: 10px">
            <el-col :span="3" :offset="1">
              <span>模板：</span>
            </el-col>
            <el-col :span="6">
              <el-select size="mini" v-model="templateNameCurrent" style="width: 100%" @change="currentTemplateChange">
                <el-option v-for="item in templateNames" :key="item.name" :label="item.name"
                           :value="item.name"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row align="middle" style="margin-bottom: 10px">
            <el-col :span="3" :offset="1">
              <span>  深度比例：</span>
            </el-col>
            <el-col :span="6" align="left">
              <el-select size="mini" v-model="depthScale" style="width: 100%">
                <el-option v-for="item in scaleOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="4" align="left">
              <span>分层级别:</span>
            </el-col>
            <el-col :span="6">
              <el-select size="mini" v-model="dataStratumLev" style="width: 100%" @change="stratumLevelChanged">
                <el-option v-for="item in stratumLevelOptions" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-row>

          <el-row align="middle" style="height:35px">
            <el-col :span="3" :offset="1" align="left">
              <span>显示范围:</span>
            </el-col>
            <el-col :span="7" align="left">
              <el-radio v-model="depthType" :label=0>深度</el-radio>
            </el-col>
            <el-col v-if="depthType === 0" :span="3" :offset="3">
              <span>  顶部深度：</span>
            </el-col>
            <el-col v-if="depthType === 1" :span="3" :offset="3">
              <span>  顶部层位：</span>
            </el-col>
            <el-col v-if="depthType === 0" :span="6" align="left">
              <el-input size="mini" v-model.number="topDepth" style="width:100%"></el-input>
            </el-col>
            <el-col v-if="depthType === 1" :span="6" align="left">
              <el-select size="mini" v-model="topLayer" style="width: 100%">
                <el-option v-for="item in layerOption" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row align="middle" style="height:35px">
            <el-col :span="3" :offset="1" align="left">
            </el-col>
            <el-col :span="7" align="left">
              <el-radio v-model="depthType" :label=1>分层</el-radio>
            </el-col>
            <el-col v-if="depthType === 0" :span="3" :offset="3">
              <span>  底部深度：</span>
            </el-col>
            <el-col v-if="depthType === 1" :span="3" :offset="3">
              <span>  底部层位：</span>
            </el-col>
            <el-col v-if="depthType === 0" :span="6" align="left">
              <el-input size="mini" v-model.number="botDepth" style="width:100%"></el-input>
            </el-col>
            <el-col v-if="depthType === 1" :span="6" align="left">
              <el-select size="mini" v-model="botLayer" style="width: 100%">
                <el-option v-for="item in layerOption" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div v-if="fenceStep === 2 && dataType === 1" style="margin-bottom: 124px">
          <el-row align="middle" style="margin-bottom: 10px">
            <el-col :span="3" :offset="1">
              <span>模板：</span>
            </el-col>
            <el-col :span="6">
              <el-select size="mini" v-model="templateNameCurrent" style="width: 100%" @change="currentTemplateChange">
                <el-option v-for="item in templateNames" :key="item.name" :label="item.name"
                           :value="item.name"></el-option>
              </el-select>
            </el-col>

            <el-col v-if="depthType === 0" :span="3" :offset="3">
              <span>  顶部深度：</span>
            </el-col>
            <el-col v-if="depthType === 0" :span="6" align="left">
              <el-input size="mini" v-model.number="topDepth" style="width:100%"></el-input>
            </el-col>

            <el-col v-if="depthType === 1" :span="3" :offset="3">
              <span>  顶部层位：</span>
            </el-col>
            <el-col v-if="depthType === 1" :span="6" align="left">
              <el-select size="mini" v-model="topLayer" style="width: 100%">
                <el-option v-for="item in layerOption" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row align="middle" style="margin-bottom: 10px">
            <el-col :span="3" :offset="1">
              <span>  深度比例：</span>
            </el-col>
            <el-col :span="6" align="left">
              <el-select size="mini" v-model="depthScale" style="width: 100%">
                <el-option v-for="item in scaleOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>

            <el-col v-if="depthType === 0" :span="3" :offset="3">
              <span>  底部深度：</span>
            </el-col>
            <el-col v-if="depthType === 0" :span="6" align="left">
              <el-input size="mini" v-model.number="botDepth" style="width:100%"></el-input>
            </el-col>

            <el-col v-if="depthType === 1" :span="3" :offset="3">
              <span>  底部层位：</span>
            </el-col>
            <el-col v-if="depthType === 1" :span="6" align="left">
              <el-select size="mini" v-model="botLayer" style="width: 100%">
                <el-option v-for="item in layerOption" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row align="middle" style="margin-bottom: 10px">
            <el-col :span="3" :offset="1" align="left">
              <span>显示范围:</span>
            </el-col>
            <el-col :span="3" align="left">
              <el-radio v-model="depthType" :label=0>深度</el-radio>
            </el-col>
            <el-col :span="3" align="left">
              <el-radio v-model="depthType" :label=1>分层</el-radio>
            </el-col>
          </el-row>
        </div>

        <el-row justify="end" align="middle" style="margin-top: 20px">
          <el-col :span="8">
            <el-button-group>
              <el-button class="pushButton" size="mini" type="primary" icon="el-icon-arrow-left"
                         :disabled="fenceStep === 0" @click="prevStep">上一步
              </el-button>
              <el-button class="pushButton" size="mini" type="primary"
                         v-if="(fenceStep < 2 && dataType === 0) ||(fenceStep < 2 && dataType === 1)"
                         :disabled="fenceStep === 2" @click="nextStep">下一步<i class="el-icon-arrow-right"></i>
              </el-button>
              <el-button class="pushButton" size="mini" type="primary" v-if="fenceStep === 2" @click="fenceCreateOK">完
                成 <i class="el-icon-arrow-right"></i></el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-dialog>
    </div>

    <!--数据导入弹窗-->
    <div v-dialogDrag>
      <el-dialog
          v-model="importDialogVisible"
          title="数据导入"
          width="680px"
          :close-on-click-modal="false"
      >
        <el-table
            :data="theHeaderFiles"
            width="100%"
            max-height="600px"

        >
          <el-table-column prop="label" label="目标字段" align="center" header-align="center">
            <template #default="scope">
              <span>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center" header-align="center">
            <template #default="scope">
              <el-select v-model="scope.row[scope.column.property]" placeholder="Select" size="large">
                <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="to" label="上传字段" align="center" header-align="center">
            <template #default="scope">
              <el-select v-model="scope.row[scope.column.property]" placeholder="请选择" size="large"
                         @change="dataChange">
                <el-option
                    v-for="item in xlsHeader"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="importDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="dataModify">预览</el-button>
            <el-button type="primary" @click="modifyOk">确认</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!-- 数据预览弹窗-->
    <div v-dialogDrag>
      <el-dialog
          v-model="modifyDialogVisible"
          title="数据预览"
          fullscreen
          :close-on-click-modal="false">
        <el-table
            :data="xlsData"
            stripe
            height="800"
            style="width: 100%"
        >
          <el-table-column
              v-for="item in theHeaderFiles"
              :prop="item.to"
              :key="item.to"
              :label="item.label"
              align="center"
              header-align="center">
            <template #default="scope">
              <span>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="modifyDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="modifyOk">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as WellLog from "../../public/static/js/welllog"
//import jsonData from '../../public/static/data/fenceData.json'
import template from '../../public/static/data/fenceTemplate.json'
import { ElMessage } from 'element-plus';
import FenceConfig from './FenceConfig.vue'
import axios from "axios";
import XLSX from "xlsx";
import BlockSelect from "@/components/blockSelect";

let map = null;
export default {
  name: "FenceView",
  mounted() {
    this.initFence()
  },
  components: {
    BlockSelect,
    FenceConfig
  },
  props:{
    templateIndex:{
      default: false
    },
  },
  methods : {
    //点击 设置 按钮（图层管理）
    layerDataSet(index,row){
      console.log(index);
      console.log(row);
      this.$refs.upload.click();
      this.theHeaderFiles=JSON.parse(JSON.stringify(this.local_tableData[index].header));
      this.localDatsIndex=index;
      // if (row.dataType=="dataSrc")
      //   this.isLayerDataSrc=true;
      // else if (row.dataType=="localFile"){
      //   this.$refs.upload.click();
      //   this.theHeaderFiles=JSON.parse(JSON.stringify(this.layer_tableData[index].header));
      // }
    },
    //excel文件上传
    takeExcelInfo() {
      this.curFileName = "";
      this.myFiles = this.$refs.upload.files;
      this.excel();
    },
    //excel文件上传
    excel() {
      if (!this.$refs.upload.files) {
        return
      }
      let files = this.$refs.upload.files;
      // console.log("file:",files[0].name);
      this.curFileName = files[0].name;
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        try {
          let data = e.target.result;
          const workbook = XLSX.read(data, {type: "binary"});
          let sheetNames = workbook.SheetNames;
          let workSheet = workbook.Sheets[sheetNames];
          let xlsData = XLSX.utils.sheet_to_json(workSheet);
          let xlsHeader = [];
          let xlsHeaderList = {};//记录数据表头信息，用于判断 xlsHeader 添加重复的表头数据
          for (let j = 0; j < xlsData.length; j++) {
            for (let i in xlsData[j]) {
              if (!(i in xlsHeaderList)) {
                xlsHeader.push({
                  isPrimary: false,
                  to: "",
                  type: "string",
                  from: i,
                  label: i
                })
                xlsHeaderList[i] = "";
              }
            }
          }
          this.theHeaderFiles.forEach(item => {
            // console.log("原字段：",item.label)
            xlsHeader.forEach(Item => {
              if (item.label == Item.label) {
                console.log("上传字段：",Item.label)
                item.to = Item.label
              }
            })
          })
          this.xlsData = xlsData;
          this.xlsHeader = xlsHeader;
          this.$refs.upload.value = "";
          this.importDialogVisible = true;
          // console.log(xlsHeader)
          // console.log(xlsData)
          //console.log(this.theHeaderFiles)
        } catch {
          return false
        }
      }
      if (files.length != 0) {
        fileReader.readAsBinaryString(files[0])
      }
    },//数据导入下拉监听
    dataChange(val) {
      let num = 0;
      let num1 = 0;
      // console.log(val)
      for (let i in this.theHeaderFiles) {
        if (val == this.theHeaderFiles[i].COLUMN_NAME) {
          num++;
          if (num > 1) {
            ElMessage("目标字段不得重复")
            this.theHeaderFiles[i].COLUMN_NAME = "";
          }
        }
      }
      for (let i in this.theHeaderFiles) {
        // console.log(this.theHeaderFiles[i])
        if (val == this.theHeaderFiles[i].to) {
          num1++;
          if (num1 > 1) {
            ElMessage("上传字段不得重复")
            this.theHeaderFiles[i].to = "";
          }
        }
      }
      console.log(this.theHeaderFiles)
    },
    //数据预览
    dataModify() {
      // console.log(this.xlsHeader)
      // console.log(this.xlsData)
      // console.log(this.theHeaderFiles)
      for (let i in this.theHeaderFiles){
        // console.log(this.theHeaderFiles[i].to)
        if (this.theHeaderFiles[i].to==undefined || this.theHeaderFiles[i].to==""){
          ElMessage("有未填写信息,请填写完毕后预览数据")
          return
        }
      }
      this.modifyDialogVisible = true;
    },
    isNumeric(value){
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    //数据预览 确认按钮
    modifyOk(){
      let data=[];//构建对应图层的表数据
      let fieldDatalist = [];
      // console.log("headerfile:",this.theHeaderFiles)
      for (let j=0; j < this.xlsData.length; j++) {
        let dataOne = {};//一条表数据
        let fieldData = {};
        for (let i = 0; i < this.theHeaderFiles.length; i++) {
          let label = this.theHeaderFiles[i].label;//图层字段
          let to = this.theHeaderFiles[i].to;//上传文件对应字段
          let field = this.theHeaderFiles[i].field
          let value=this.xlsData[j][to];//对应值
          if (value==undefined){
            value="";
          }
          else if(this.theHeaderFiles[i].type == "string"){
            if(this.isNumeric(value)) {
              value = JSON.stringify(value);
            }
          }
          dataOne[label]=value;
          fieldData[field]=value;
        }
        data.push(dataOne);
        fieldDatalist.push(fieldData);
      }
      this.local_tableData[this.localDatsIndex].fieldData=fieldDatalist;
      this.local_tableData[this.localDatsIndex].data=data;
      this.local_tableData[this.localDatsIndex].seted=true;
      // console.log("myfiles:",this.myFiles,this.$refs.upload.files);
      if(this.myFiles.length >0){
        this.local_tableData[this.localDatsIndex].fileName = this.myFiles[0].name;
      }
      else{
        this.local_tableData[this.localDatsIndex].fileName = this.curFileName.length==0?"已设置":this.curFileName;
      }
      this.importDialogVisible = false;
      this.modifyDialogVisible = false;

    },
    initFence() {
      this.loadTemplateNames();
      this.loadCurrentWells();
      this.loadStratumLevels();
      // this.createFence(template, jsonData);
    },
    createFence(temp, data) {
      const container = document.querySelector('#fence_container')
      WellLog.clearMap(container);
      map = WellLog.createFenceMap(container, temp, data);
    },
    loadTemplateNames() {
      const url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/template/search";
      const options = {
        params: {
          AppID : "7cff6a1e-1270-4ab0-a8c6-f902b9491fb7",
          AppSercect : "vdk7dhraws5x676pkxywifms",
          Authorization: localStorage.getItem("lyqtJwt")
        }
      };
      axios.get(url, options).then(res => {
        // console.log('---------加载模板名称----------');
        // console.log(res);
        let sysTemplates = [];
        let userTemplates = [];
        let nameMatch = false;

        for(const item of res.data.data) {
          const type = item["templateType"];
          const isSystem = type === "系统";
          const name = (isSystem ? "[系统]":"[个人]") + item["templateName"];
          const template = {id : item["templateId"], type:type, name:name};

          if (isSystem) {
            sysTemplates.push(template);
          } else {
            userTemplates.push(template);
          }
          if (!nameMatch) {
            nameMatch = name === this.templateNameCurrent;
          }
        }

        this.templateNames = sysTemplates.concat(userTemplates);
        if (!nameMatch && this.templateNames.length > 0) {
          this.templateNameCurrent = this.templateNames[0]['name'];
        }
      }).catch(err => {
        console.log(err);
      });
    },
    loadStratumLevels() {
      const url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/map/leve";
      axios.get(url, {params:{Authorization:localStorage.getItem("lyqtJwt")}}).then(res => {
        this.stratumLevelOptions = [];

        for(const i in res.data.data) {
          const item = {label:res.data.data[i], value:i};
          this.stratumLevelOptions.push(item);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    loadStratums() {
      if (this.selectedWells.length === 0) {
        return;
      }
      const params = {
        "well" : [],
        "level" : this.dataStratumLev,
        "autorization" : localStorage.getItem("lyqtJwt")
      };

      for(const item of this.selectedWells) {
        params["well"].push(item.wellName);
      }

      const url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/map/layered";
      axios.post(url, params).then(res => {
        this.layerOption = [];
        console.log("fence_layered:",res.data.data)
        if(res.data.data == null || res.data.data == undefined){
          ElMessage({type:"info",message:"未找到地层数据！"});
        }
        else{
          for(const layer of res.data.data) {
            this.layerOption.push({label:layer,value:layer});
          }
          if(this.layerOption.length>0){
            this.topLayer = this.layerOption[0].label;
            this.botLayer = this.layerOption[this.layerOption.length-1].label;
          }
          this.fenceStep += 1;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    setShowConnect() {
      if (map != null) {
        map.showConnect = this.showConnect;
      }
    },
    setShowLegend() {
      if (map != null) {
        map.showLegend = this.showLegend;
      }
    },
    setRotateAngle() {
      if (map != null) {
        map.rotateAngle = this.rotateAngle;
      }
    },
    zoomIn() {
      if (map != null) {
        map.ZoomIn();
      }
    },
    zoomOut() {
      if (map != null) {
        map.ZoomOut();
      }
    },
    zoomFit(){
      if (map != null) {
        map.ZoomFit();
      }
    },
    zoomRect(){
      if (map != null) {
        map.ZoomRect();
      }
    },
    setupTemplate() {
      this.showConfig = !this.showConfig;
      if (this.showConfig) {
        this.checkTemplateName = false;
        this.$refs.fenceEdit.createDataType = this.dataType;
        this.$refs.fenceEdit.reloadTemplate();
        this.$refs.fenceEdit.layerOption=this.layerOption;
      }
    },
    cancelConfig() {
      this.showConfig = false;
      this.$refs.fenceEdit.endEdit();
    },
    submitConfig() {
      this.fenceConfig = JSON.parse(JSON.stringify(this.$refs.fenceEdit.getTemplate()));
      this.$refs.fenceEdit.endEdit();
      this.showConfig = false;
      for(const config of this.fenceConfig) {
        if (config.type === 'WellSetting') {
          this.depthType = config.depthType;
          this.topDepth = config.topDepth;
          this.botDepth = config.botDepth;
          this.topLayer = config.topLayer;
          this.botLayer = config.botLayer;
        }
      }

      this.fenceCreateOK();
      // this.createFence(this.fenceConfig, jsonData);  // 使用测试数据
      // this.loadData();                                  // 使用真实数据
    },
    templateSaveAs(){
      this.saveAsVisible = true;
    },
    prepareParam(){
      const data = {"jwt":localStorage.getItem("lyqtJwt"), "mode" : this.dataType};

      if (this.dataType === 0) {
        data["fenceDiagramDTOList"]=[];

      const curves = [];
      // data['depthType'] = this.depthType;
      // data['topDepth'] = this.topDepth;
      // data['botDepth'] = this.botDepth;
      // data['depthStratumLev'] = Number.parseInt(this.dataStratumLev);
      // data['dataStratumLev'] = Number.parseInt(this.dataStratumLev);
      // data['topStratum'] = this.topLayer;
      // data['botStratum'] = this.botLayer;
      // data['jwt'] = 'jwtStr';
      //
      // for(const config of this.fenceConfig) {
      //   if (config.type === 'WellSetting') {
      //     for(const track of config.children) {
      //       if (track.type === 'LogCurveTrack') {
      //         for(const curve of track.children) {
      //           curves.push(curve.curveName);
      //         }
      //       }
      //     }
      //   }
      // }

      for(const config of this.fenceConfig) {
        if (config.type === 'WellSetting') {
          config.depthType = this.depthType;
          config.topDepth = this.topDepth;
          config.botDepth = this.botDepth;
          config.topLayer = this.topLayer;
          config.botLayer = this.botLayer;
          data['depthType'] = config.depthType;
          data['topDepth'] = config.topDepth;
          data['botDepth'] = config.botDepth;
          data['depthStratumLev'] = Number.parseInt(this.dataStratumLev);
          data['dataStratumLev'] = Number.parseInt(this.dataStratumLev);
          data['topStratum'] = config.topLayer;
          data['botStratum'] = config.botLayer;
          data['jwt'] = 'jwtStr';

          for(const track of config.children) {
            if (track.type === 'LogCurveTrack') {
              for(const curve of track.children) {
                curves.push(curve.curveName);
              }
            }
          }
        }
      }

        for(const well of this.selectedWells){
          data["fenceDiagramDTOList"].push(
              {
                "well" : well.wellName,
                "curve" : curves
              }
          );
        }
      }

      // const wells = ['B5-12', 'B5-11','B5-14', 'B5-15', 'B5-16', 'B5-17', 'B5-19'];


      return data;
    },
    loadData() {
      this.fenceLoading = true;

      const url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/map/fence";
      const params = this.prepareParam();
      // console.log("fenceParam",params)
      // console.log(params);
      axios.post(url, params).then(res => {
        const data = res.data.data;
        // console.log("----------------栅状图数据-----------------");
        // console.log(data);
        // console.log(this.fenceConfig);
        this.createFence(this.fenceConfig, data);
        this.fenceLoading = false;
      }).catch(err => {
        console.log(err);
        this.fenceLoading = false;
      });
    },
    manageTemplate() {
      this.setupDialogVisible = true;
      this.checkTemplateName = true;
    },
    recreateFence() {
      this.fenceStep = 0;
      this.initDialogVisible = true;
    },
    deleteTemplate() {
      if (this.templateNameManageCurrent.length === 0) {
        ElMessage({type:"info",message:"请选择需要删除的模板！"});
        return;
      }

      const isSystem = this.templateNameManageCurrent.indexOf('[系统]') !== -1;
      let templateId = '';
      for(const template of this.templateNames) {
        if (template['name'] === this.templateNameManageCurrent) {
          templateId = template['id'];
          break;
        }
      }

      if (!this.isAdmin() && isSystem) {
        ElMessage({type:"info", message:"您不是管理员，无法删除系统模板！"});
        return;
      }

      if (isSystem) {
        let sysCount = 0;
        this.templateNames.forEach(function(item){if (item['type'] === '系统') sysCount++;});
        if (sysCount <= 1) {
          ElMessage({type:"info", message:"请至少保留一个系统模板！"});
          return;
        }
      }

      const url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/template/delete";

      const data = new FormData();
      data.append("templateId", templateId);
      data.append("type", isSystem ? "系统" : "个人");
      data.append("AppID", "7cff6a1e-1270-4ab0-a8c6-f902b9491fb7");
      data.append("AppSercect", "vdk7dhraws5x676pkxywifms");
      data.append("Authorization", localStorage.getItem("lyqtJwt"));

      const options = {headers : {'Content-Type':'multipart/form-data'}};

      axios.delete(url, {data:data}, options).then(res => {
        console.log(res);
        ElMessage({type:"info", message:"模板已删除！"});
        this.loadTemplateNames();
      }).catch(err => {
        console.log(err);
        ElMessage({type:"info", message:"模板删除失败！"});
      });
    },
    clickSaveAs() {
      if (this.saveAsTemplateName.length === 0) {
        ElMessage({type:"info",message:"请先选择模板！"});
        return;
      }

      this.saveAsVisible = true;
    },
    applyTemplate() {
      if (this.templateNameManageCurrent.length === 0) {
        ElMessage({type:"info",message:"请先选择模板！"});
        return;
      }

      this.setupDialogVisible = false;
      this.createFenceByTemplate(this.templateNameManageCurrent);
    },
    addAllWell() {
      this.selectedWells = JSON.parse(JSON.stringify(this.currentBlockWells));
    },
    addSelectedWell() {
      if (this.currentWellSelection) {
        // console.log(this.currentWellSelection);

        for(const sel of this.currentWellSelection) {
          let found = false;

          for(const item of this.selectedWells) {
            if (item.wellName === sel.wellName) {
              found = true;
              break;
            }
          }
          if (!found) {
            this.selectedWells.push({wellName : sel.wellName})
          }
        }

        this.currentWellSelection = null;
        this.$refs.currentWellTable.clearSelection();
      }
    },
    removeSelectedWell() {
      if (this.currentSelectWell) {
        for(const sel of this.currentSelectWell) {
          let idx = -1;
          for (let i = 0; i < this.selectedWells.length; i++) {
            const item = this.selectedWells[i];
            if (item.wellName === sel.wellName) {
              idx = i;
              break
            }
          }
          if (idx !== -1) {
            this.selectedWells.splice(idx, 1);
          }
        }
      }
    },
    removeAllWell() {
      this.selectedWells = [];
    },
    blockWellCheckChange(selection) {
      this.currentWellSelection = selection;
    },
    templateSelectChange(val) {
      if (val === null) {
        this.templateNameManageCurrent = '';
        this.saveAsTemplateName = '';
      } else {
        this.templateNameManageCurrent = val.name;
        this.saveAsTemplateName = this.templateNameManageCurrent.substring(4);
      }
    },
    currentTemplateChange(val) {
      this.saveAsTemplateName = val.substring(4);
    },
    selectWellCheckChange(val) {
      this.currentSelectWell = val;
    },
    moveUp() {
      if (this.currentSelectWell && this.currentSelectWell.length === 1) {
        const sel = this.currentSelectWell[0];
        let idx = -1;
        for (let i = 0; i < this.selectedWells.length; i++) {
          const item = this.selectedWells[i];
          if (item.wellName === sel.wellName) {
            idx = i;
            break
          }
        }
        if (idx > 0) {
          const item = this.selectedWells[idx];
          this.selectedWells.splice(idx, 1);
          this.selectedWells.splice(idx-1, 0, item);
        }
      }
    },
    moveDown() {
      if (this.currentSelectWell && this.currentSelectWell.length === 1) {
        const sel = this.currentSelectWell[0];
        let idx = -1;
        for (let i = 0; i < this.selectedWells.length; i++) {
          const item = this.selectedWells[i];
          if (item.wellName === sel.wellName) {
            idx = i;
            break
          }
        }
        if (idx !== -1 && idx+1 < this.selectedWells.length) {
          const item = this.selectedWells[idx];
          this.selectedWells.splice(idx, 1);
          this.selectedWells.splice(idx+1, 0, item);
        }
      }
    },
    stratumLevelChanged(val) {
      this.dataStratumLev = val;
      this.loadStratums();
    },
    prevStep() {
      if (this.fenceStep > 0) {
        this.fenceStep -= 1;
      }
    },
    nextStep() {
      if (this.fenceStep === 1 && this.dataType === 0) {
        if (this.selectedWells.length < 2) {
          ElMessage({type:"info",message:"请至少选择2口井！"})
          return;
        }
        this.fenceWells = this.selectedWells;
        this.loadStratums();
      }
      else{
        if(this.fenceStep === 1 && this.dataType === 1){
          if(!this.local_tableData[0].seted || !this.local_tableData[1].seted || !this.local_tableData[3].seted){
            ElMessage({type:"info",message:"地层数据、砂岩数据和解释结论为必备数据，请设置后再继续！"});
            return;
          }
          // console.log("localstartumdata:",this.local_tableData[0].fieldData)
          this.topDepth = parseFloat(this.local_tableData[0].fieldData[0].topDepth);
          this.botDepth = parseFloat(this.local_tableData[0].fieldData[0].botDepth);
          let layerWellCntMap = {};
          let wellCntMap = {};
          let wellcnt = 0;
          let wellName = "";
          this.layerOption = [];
          for(let i=0;i<this.local_tableData[0].fieldData.length;i++){
            let fieldObj = this.local_tableData[0].fieldData[i];
            // console.log(fieldObj.topDepth,fieldObj.botDepth);
            if(parseFloat(fieldObj.topDepth) < this.topDepth) this.topDepth = parseFloat(fieldObj.topDepth);
            if(parseFloat(fieldObj.botDepth) > this.botDepth) this.botDepth = parseFloat(fieldObj.botDepth);
            if(layerWellCntMap[fieldObj.name] == null || layerWellCntMap[fieldObj.name] == undefined)
            {
              layerWellCntMap[fieldObj.name] = 1;
            }
            else{
              layerWellCntMap[fieldObj.name] += 1;
            }
            if(wellCntMap[fieldObj.well] == null || wellCntMap[fieldObj.well] == undefined){
              wellcnt++;
              wellCntMap[fieldObj.well] = [];
            }
            wellCntMap[fieldObj.well].push(fieldObj.name)
            wellName = fieldObj.well;
          }
          for(let lawelidx = 0;lawelidx<wellCntMap[wellName].length;lawelidx++){
            let layername = wellCntMap[wellName][lawelidx];
            if(layerWellCntMap[layername] == wellcnt){
              this.layerOption.push({label:layername,value:layername})
            }
          }
          // console.log(this.topDepth,this.botDepth,this.layerOption)
          // this.topDepth = 80;
          // this.botDepth = 130;
          if(this.layerOption.length>0){
            this.topLayer = this.layerOption[0].label;
            this.botLayer = this.layerOption[this.layerOption.length-1].label;
          }
          // this.depthType = 0;
        }
        this.fenceStep += 1;
      }
    },
    isAdmin() {
      const userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession === null || userInfoSession === undefined) {
        return false;
      }
      return userInfoSession.id === '1cp3dlad8roa54lsocyit126';
    },
    createFenceByUserData() {

    },
    async loadTemplate(name) {
      // 获取模板
      let templateId = '';
      for(const template of this.templateNames) {
        if (template['name'] === name) {
          templateId = template['id'];
          break;
        }
      }

      if (templateId === '') {
        return;
      }

      const url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/template/details";
      await axios.get(url, {params:{templateId:templateId}}).then(res=>{
        this.fenceConfig = res.data;

        // 根据当前配置修改模板部分参数
        for(const config of this.fenceConfig) {
          if (config.type === 'WellSetting') {
            config.depthScale = this.depthScale;
            config.depthType = this.depthType;
            config.stratumLevel = this.dataStratumLev;
            if (this.depthType === 0) {
              config.topDepth = this.topDepth;
              config.botDepth = this.botDepth;
            } else {
              config.topLayer = this.topLayer;
              config.botLayer = this.botLayer;
            }
          }
        }
      }).catch(err => {
        console.log(err);
      });
    },
    createFenceByTemplate(name) {
      // 获取模板
      let templateId = '';
      for(const template of this.templateNames) {
        if (template['name'] === name) {
          templateId = template['id'];
          break;
        }
      }

      if (templateId === '') {
        return;
      }

      const url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/template/details";
      axios.get(url, {params:{templateId:templateId}}).then(res=>{
        this.fenceConfig = res.data;

        // 根据当前配置修改模板部分参数
        for(const config of this.fenceConfig) {
          if (config.type === 'WellSetting') {
            config.depthScale = this.depthScale;
            config.depthType = this.depthType;
            config.stratumLevel = this.dataStratumLev;
            if (this.depthType === 0) {
              config.topDepth = this.topDepth;
              config.botDepth = this.botDepth;
            } else {
              config.topLayer = this.topLayer;
              config.botLayer = this.botLayer;
            }
          }
        }
        // 重新生成栅状图
        this.fenceCreateOK();
        //this.loadData();
      }).catch(err => {
        console.log(err);
      });
    },
    fenceCreateOK () {
      // if (this.dataType === 1) {
      //   if(!this.local_tableData[0].seted || !this.local_tableData[1].seted){
      //     ElMessage({type:"info",message:"地层数据和砂岩数据为必备数据，请设置后再继续！"});
      //     return;
      //   }
      // }
      this.initDialogVisible = false;
      let wellList=[];
      let datadict = {};
      let fullwellDict = {};

      let stratumobj = this.local_tableData[0];
      let stratumWellLimit = {};
      if(stratumobj.type == "地层"){
        let stratumObjJson = stratumobj.fieldData;
        for(let j=0;j<stratumObjJson.length;j++){
          if(stratumWellLimit[stratumObjJson[j].well] == undefined) {
            stratumWellLimit[stratumObjJson[j].well] = {};
            stratumWellLimit[stratumObjJson[j].well].minDepth = 99999999;
            stratumWellLimit[stratumObjJson[j].well].maxDepth = -99999999;
          }

          if(stratumObjJson[j].name == this.topLayer || stratumObjJson[j].name == this.botLayer){
            if(parseFloat(stratumWellLimit[stratumObjJson[j].well].minDepth) > parseFloat(stratumObjJson[j].topDepth)) stratumWellLimit[stratumObjJson[j].well].minDepth=stratumObjJson[j].topDepth;
            if(parseFloat(stratumWellLimit[stratumObjJson[j].well].maxDepth) < parseFloat(stratumObjJson[j].botDepth)) stratumWellLimit[stratumObjJson[j].well].maxDepth=stratumObjJson[j].botDepth;
          }
        }
      }
      // console.log("stratumLimit:",stratumWellLimit);
      for(let i=0;i<this.local_tableData.length;i++){
        let obj = this.local_tableData[i];
        let objJson = {};
        if(obj.seted){
          objJson = obj.fieldData;
          let wellDict = {};
          for(let j=0;j<objJson.length;j++){
            if(wellDict[objJson[j].well] == undefined) {
              wellDict[objJson[j].well] = [];
              if(fullwellDict[objJson[j].well] == undefined){
                fullwellDict[objJson[j].well] = obj.type;
                wellList.push(objJson[j].well);
              }
            }
            let newobj = JSON.parse(JSON.stringify(objJson[j]));
            delete newobj.well;
            // console.log(objJson[j].well)
            if(parseFloat(newobj.topDepth)>=parseFloat(stratumWellLimit[objJson[j].well].minDepth) && parseFloat(newobj.botDepth)<=parseFloat(stratumWellLimit[objJson[j].well].maxDepth)){
              newobj.topDepth = parseFloat(newobj.topDepth);
              newobj.botDepth = parseFloat(newobj.botDepth);
              // if(i==1) newobj.core = "角砾岩"
              wellDict[objJson[j].well].push(newobj);
            }
          }
          datadict[obj.type] = wellDict;
          // switch (i) {
          //   case 0:
          //     console.log("ppppppp",objJson)
          //     break;
          // }
        }
      }
      // console.log("pppppp",wellList,datadict)
      let newjsonData=[];
      for(let k=0;k<wellList.length;k++){
        let wellName = wellList[k];
        let wellObj = {};
        wellObj["wellName"] = wellName;
        for(let l=0;l<this.local_tableData.length;l++){
          if(this.local_tableData[l].seted){
            wellObj[this.local_tableData[l].typeField] = datadict[this.local_tableData[l].type][wellName];
            // console.log(this.local_tableData[l].typeField,wellObj[this.local_tableData[l].typeField])
          }
        }
        wellObj["logCurve"] = JSON.parse(JSON.stringify(this.defCurveData));
        newjsonData.push(wellObj);
      }

      //console.log("fenceok",this.dataType,jsonData,newjsonData)
      if (this.dataType === 1) {
        for(const config of this.fenceConfig) {
          if (config.type === 'WellSetting') {
            config.depthType = this.depthType;
            config.topDepth = this.topDepth;
            config.botDepth = this.botDepth;
            config.topLayer = this.topLayer;
            config.botLayer = this.botLayer;

          }
        }
        console.log("----------fenceCreateOK----------");
        console.log(this.fenceConfig, newjsonData)
        this.createFence(this.fenceConfig, newjsonData);
      } else {
        this.loadData();
      }

      // if (this.dataType === 0) {
      //   this.loadTemplate(this.templateNameCurrent);
      // }
      // this.loadData();
    },
    fenceCreateCancel() {
      this.initDialogVisible = false;
    },
    saveTemplateOK() {
      this.saveAsVisible = false;

      // 模板保存，模板名冲突检测
      if (this.checkTemplateName) {
        const templateName = this.saveAsTemplateType === 1 ? "[系统]" : "[个人]" + this.saveAsTemplateName;
        for(const item of this.templateNames) {
          if (item.name === templateName) {
            ElMessage({type:"info",message:"模板名称已存在！"})
            return;
          }
        }
      }

      const url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/template/add";
      const options = {
        params: {
          AppID : "7cff6a1e-1270-4ab0-a8c6-f902b9491fb7",
          AppSercect : "vdk7dhraws5x676pkxywifms",
          Authorization: localStorage.getItem("lyqtJwt"),
          templateName: this.saveAsTemplateName,
          type: this.saveAsTemplateType === 1 ? "系统" : "个人"
        }
      };
      axios.post(url, this.fenceConfig, options).then(res => {
        ElMessage({type:"info",message:"模板保存成功！"})
        console.log(res);
        this.loadTemplateNames();
      }).catch(err => {
        console.log(err);
      });
    },
    saveTemplateCancel() {
      this.saveAsVisible = false;
    },
    loadCurrentWells() {
      const block = localStorage.getItem("checkedBlock");
      const blockType = localStorage.getItem("blockType");
      if (block === null) {
        console.log("checkedBlock is null!")
        return;
      }

      this.currentBlockWells = [];
      let url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/wellData";
      if(blockType === "02")
        url=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellData";

      axios.post(url, block, {headers:{"Content-Type": "application/json"}}).then((res) => {
        for(const item of res.data) {
          for(const subItem of item.children) {
            for(const gradSubItem of subItem.children) {
              this.currentBlockWells.push({wellName: gradSubItem.label});
            }
          }
          break;
        }
      }).catch((err) => {
        console.log(err);
      })
    }
  },
  data : function (){
    return {
      templateInfo: {
        moduleid:"fenceView"
      },
      local_tableData:[
        {
          type: "地层",
          typeField:"stratum",
          fileName:"",
          seted: false,//是否已配置
          header:[
            {
              label:"井名",
              field:"well",
              type:"string",
            },{
              label:"地层名",
              field:"name",
              type:"string",
            }
            ,{
              label:"顶深",
              field:"topDepth",
              type:"string",
            }
            ,{
              label:"底深",
              field:"botDepth",
              type:"string",
            }
          ],
          data:[],
          fieldData:[]
        },
        {
          type: "砂岩",
          typeField:"sand",
          fileName:"",
          seted: false,//是否已配置
          header:[
            {
              label:"井名",
              field:"well",
              type:"string",
            },
            {
              label:"砂岩名",
              field:"name",
              type:"string",
            }
            ,{
              label:"砂岩顶深",
              field:"topDepth",
              type:"string",
            }
            ,{
              label:"砂岩底深",
              field:"botDepth",
              type:"string",
            },
            {
              label:"地层名",
              field:"stratum",
              type:"string",
            }
            ,{
              label:"地层顶深",
              field:"refTop",
              type:"string",
            }
            ,{
              label:"地层底深",
              field:"refBot",
              type:"string",
            },
            {
              label:"沉积相",
              field:"litho",
              type:"string",
            },
            {
              label:"岩性",
              field:"core",
              type:"string",
            }
          ],
          data:[],
          fieldData:[]
        },
        {
          type: "射孔",
          typeField:"perf",
          fileName:"",
          seted: false,//是否已配置
          header:[
            {
              label:"井名",
              field:"well",
              type:"string",
            },
            {
              label:"砂岩名",
              field:"name",
              type:"string",
            }
            ,{
              label:"射孔顶深",
              field:"topDepth",
              type:"number",
            }
            ,{
              label:"射孔底深",
              field:"botDepth",
              type:"number",
            }
          ],
          data:[],
          fieldData:[]
        },
        {
          type: "解释结论",
          typeField:"explain",
          fileName:"",
          seted: false,//是否已配置
          header:[
            {
              label:"井名",
              field:"well",
              type:"string",
            },
            {
              label:"砂岩名",
              field:"name",
              type:"string",
            },
            {
              label:"解释顶深",
              field:"topDepth",
              type:"number",
            }
            ,{
              label:"解释底深",
              field:"botDepth",
              type:"number",
            },
            {
              label:"解释结论",
              field:"value",
              type:"string",
            }
          ],
          data:[],
          fieldData:[]
        },
        {
          type: "曲线",
          typeField:"logCurve",
          fileName:"",
          seted: false,//是否已配置
          header:[
            {
              label:"井名",
              field:"well",
              type:"string",
            }
          ],
          data:[],
          fieldData:[]
        }
      ],
      wellSet:false,//井位是否已配置本地文件
      myFiles:"",//记录上传excel文件内容
      curFileName:"",//记录当前文件名
      localDatsIndex:0,
      theHeaderFiles:[],//对应图层表头
      xlsData:[],//上传excel文件数据
      xlsHeader:[],//上传excel文件表头
      importDialogVisible:false,//数据导入弹窗标识
      modifyDialogVisible:false,//数据预览弹窗标识
      typeOptions: [
        {
          label: "字符",
          value: "string"
        }, {
          label: "日期",
          value: "date"
        }, {
          label: "数值",
          value: "number"
        }],//数据导入类型列表
      fenceLoading : false,
      rotateAngle : 0,
      showLegend : true,
      showConnect : true,
      showConfig : false,
      setupDialogVisible : false,
      saveAsVisible : false,
      // templateType : 2,
      depthScale : 500,
      initDialogVisible : true,
      dataType : 0,
      depthType : 1,
      topLayer : 't1-1-1',
      botLayer : 't1-1-8',
      topDepth : 2150,
      botDepth : 2500,
      dataStratumLev : '3',
      // depthStratumLev : 3,
      currentBlockWell : '',
      currentSelectWell : '',
      currentWellSelection : null,
      fenceStep : 0,
      templateNameCurrent: '[系统]默认模板1',
      templateNameSelected: '[系统]默认模板1',
      templateNameManageCurrent : '',
      saveAsTemplateName : '默认模板1',
      saveAsTemplateType : 2,
      checkTemplateName : false,
      selectedWells : [
      ],
      fenceWells : ['B5-12','B5-11','B5-14','B5-15','B5-16','B5-17','B5-19'],
      currentBlockWells:[
        {wellName : 'B5-12'},
        {wellName : 'B5-11'},
        {wellName : 'B5-14'},
        {wellName : 'B5-15'},
        {wellName : 'B5-16'},
        {wellName : 'B5-17'},
        {wellName : 'B5-19'}
      ],
      templateNames:[
        {name: '[系统]默认模板1'},
        {name: '[系统]默认模板2'},
        {name: '[个人]默认模板1'},
        {name: '[个人]默认模板2'}],
      scaleOptions : [{label:"1:50",value:50},
        {label:"1:100",value:100},
        {label:"1:200",value:200},
        {label:"1:300",value:300},
        {label:"1:500",value:500},
        {label:"1:1000",value:1000},
        {label:"1:2000",value:2000},
        {label:"1:3000",value:3000}],
      layerOption:[{label:"S11", value:"S11"},
        {label:"S12", value:"S12"},
        {label:"S21", value:"S21"},
        {label:"S22", value:"S22"},
        {label:"S31", value:"S31"},
        {label:"S32", value:"S32"}],
      stratumLevelOptions:[
        {label:"系分层", value: '0'},
        {label:"组分层", value: '1'},
        {label:"段分层", value: '2'},
        {label:"小层分层", value: '3'}
      ],
      fenceConfig : JSON.parse(JSON.stringify(template)),
      defCurveData:[
        {
          "name":"GR",
          "topDepth": "1740",
          "botDepth": "1930",
          "depthStep": "0.125",
          "nullValue": "-9990",
          "value": "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"
        },
        {
          "name":"SP",
          "topDepth": "1740",
          "botDepth": "1930",
          "depthStep": "0.125",
          "nullValue": "-9999",
          "value": "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"
        }
      ]
    }
    // ,computed:
    // {
    //   maxScrollHeight()
    //   {
    //     let clientHeight = document.documentElement.clientHeight - 60 - 60;
    //     let toolBarHeight = 40;
    //     let maxHeight = clientHeight - toolBarHeight;
    //     return maxHeight + 'px';
    //   }
    // }
  },
  computed : {
    maxScrollHeight() {
      let clientHeight = document.documentElement.clientHeight-60-60;
      let toolBarHeight = 40;
      let maxHeight = clientHeight - toolBarHeight;
      return maxHeight+'px';
    }
  }
}
</script>

<style scoped>
.el-divider{
  height: 28px;
  vertical-align: center;
}
.pushButton{
}
.toolButton{
  border: 0;
  height: 24px;
}
.settingsMask{
  position: fixed;
  z-index: 1999;
  width: 100%;
  height :100%;
  top: 0;
  left: 0;
  background-color: rgba(88,87,86,0.3);
}
.settingsBack{
  position: absolute;
  height: 545px;
  width: 1100px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  padding:5px;
  background: #f4f4f4;
}
.settingsHeader{
  margin: 5px 0 10px 20px;
  font-size: 20px;
  font-family: "微软雅黑";
  font-weight: bold;
}
.settings{
  height:420px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  padding:10px;
  background: #fff;
  margin-left: 20px;
  margin-right: 20px;
}
.btnGroup{
  margin-top: 12px;
  text-align: right;
  margin-bottom: 10px;
  margin-right: 20px;
}
.fence_container {
  overflow: hidden;
}
.el-scrollbar{
  width:100%;
  height:100%;
  overflow: auto;
}

</style>